import api from '../../../core/api/api';

const BASE = '/Contabilidad';

export const contabilidadAPI = {
  getResumenMensual: (mes, anio) =>
    api.get(`${BASE}/ResumenMensual`, { params: { mes, anio } }).then(r => r.data),

  getFacturacionOSPorCentro: (mes, anio) =>
    api.get(`${BASE}/FacturacionOSPorCentro`, { params: { mes, anio } }).then(r => r.data),

  getFacturacionOSDetalleCentro: (mes, anio, idCentro) =>
    api.get(`${BASE}/FacturacionOSDetalleCentro`, { params: { mes, anio, idCentro } }).then(r => r.data),

  getIngresosPorObraSocial: (mes, anio) =>
    api.get(`${BASE}/IngresosPorObraSocial`, { params: { mes, anio } }).then(r => r.data),

  getEgresosMensuales: (mes, anio) =>
    api.get(`${BASE}/EgresosMensuales`, { params: { mes, anio } }).then(r => r.data),

  getReporteComparativo: (meses = 6) =>
    api.get(`${BASE}/ReporteComparativo`, { params: { meses } }).then(r => r.data),

  getReporteCentros: (mes, anio) =>
    api.get(`${BASE}/ReporteCentros`, { params: { mes, anio } }).then(r => r.data),
};
